export const TEST_IDENTITY_PHONE_NUMBERS: Readonly<Record<string, string>> = Object.freeze({
  'ahackett@gmail.com': '608-555-1243',
  'dmychart@me.com': '608-211-3314',
  'dogbeaker@aol.com': '410-707-2690',
  'btesta@hotmail.com': '831-600-3769',
  'tcranetest@gmail.com': '222-360-1564',
  'hsimpson@gmail.com': '217-123-3608',
  'camilalopez@epic.com': '469-555-5555',
  'derricklin@epic.com': '785-555-5555',
  'msmith60@gmail.com': '706-123-4567',
  'ellen.doe4321@gmail.com': '401-555-1940',
});

export const TEST_IDENTITY_EMAILS: readonly string[] = Object.freeze(
  Object.keys(TEST_IDENTITY_PHONE_NUMBERS),
);

export function getTestIdentityPhoneNumber(email?: string): string | undefined {
  return email
    ? TEST_IDENTITY_PHONE_NUMBERS[email.toLowerCase().trim()]
    : undefined;
}
